import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AniButton from '/src/components/AniButton';

//////////////////////////

// const useStyles = makeStyles( theme => ({
// }));

//////////////////////////

const PageTransitionDemos = (props) => {

  const { link } = props;
  const theme = useTheme();
  // const classes = useStyles(props);

  //////
  
  return ( <>

    <Typography variant="h1">
      Page Transitions
    </Typography>


    <Typography variant="h2">
      Default Transitions
    </Typography>

    <div>

      <AniButton
        to = {link}
        paintDrip
        hex = {theme.palette.secondary.main}
        duration = {0.7}
        variant = "contained"
        size = "small"
        color = "primary"
      >
        Paint Drip
      </AniButton>
      
      <AniButton
        to = {link}
        swipe
        top = "entry" // entry | exit - Which page should be on top?
        direction = "up"
        variant = "contained"
        size = "small"
        color = "primary"
      >
        Swipe Up
      </AniButton>

      <AniButton
        to = {link}
        swipe
        top = "entry" // entry | exit - Which page should be on top?
        direction = "left"
        variant = "contained"
        size = "small"
        color = "primary"
      >
        Swipe Left
      </AniButton>
      
      <AniButton
        to = {link}
        cover
        direction = "left"
        bg = {theme.palette.secondary.main}
        variant = "contained"
        size = "small"
        color = "primary"
      >
          Cover
      </AniButton>

      {/*
      NOTE: The below is commented out due to bugs (22/12/2021)
      ## Bug 1: The bg attribute gets set for all links on page rather than just that link. This is the same for colours.
      ## Bug 2: The "fixed" background attachment doesn't apply. This makes it less useful - especially because of the easing
      */}
      
      {/* <AniButton
        to = {link}
        cover
        direction = "left"
        // Don't put a space after "=" below or string literal creates error
        bg ="
          url(https://source.unsplash.com/random)
          no-repeat
          fixed
          center / cover
          padding-box
          content-box
          white
        "
        variant = "button"
        >
        Cover with image
      </AniButton> */}

      {/*
      NOTE: Not currently working (22/01/2021)
      */}
      {/* <AniButton
        to={link}
        fade
        duration={2}
        >
        (Cross) Fade
      </AniButton> */}

      {/*
      NOTE: Not sure if fade through a colour is possible - as fade isn't working
      */}
      {/* <AniButton
        fade
        duration={2}
        to={link}
        >
        Fade (through black)
      </AniButton> */}
      
    </div>


    <Typography variant="h4">
      Components
    </Typography>
    <ul>
      <li>
        <Typography variant="body1">
          <strong>Transition Link: </strong>Allows use of normal "Link" component<br/>
        </Typography>
      </li>
      <li>
        <Typography variant="body1">
          <strong>AniLink: </strong>Provides "AniLink" component that can be used in place of link components.
        </Typography>
      </li>
    </ul>


    <Typography variant="h4">
      Troubleshooting
    </Typography>

    <Typography variant="h5">
      Performance
    </Typography>
    <Typography variant="body1">
      As can be seen above, the performance of transitions which move the whole page is poor. Overlaying graphics to cover the page instead performs better.
    </Typography>
    
    <Typography variant="h5">
      Background Appearance
    </Typography>
    <Typography variant="body1">
      A background needs to be set within each page component or pages will be visible through each other during transitions that overlay both pages.
    </Typography>
    <Typography variant="body1">
      The <strong>.tl-edges</strong> and <strong>.tl-wrapper</strong> divs that are inserted between the layout component and the page components interferes with absolute positioning between them. This means the page can't be easily set to <strong>min-height: 100%</strong> to respond to fill available vertical space on short pages. If transitions aren't needed, remove Transition Link from gatsby config to remove this issue.
    </Typography>
    <Typography variant="body1">
      To work around this, the background colour is also set in the layout component directly (before tl-edges and tl-wrapper). Any transitions of short pages, however, will still only act on the pages themselves.
    </Typography>
    

  </> )

}

export default PageTransitionDemos;
